module.exports = __webpack_public_path__ + "assets/img/Ulu Pandan Park Connector.ead21c71.jpg";